import { Modal } from '@fasstech/middle-design-system';

const DeleteBeneficiaryModal = ({
  isDisplayed,
  handleRemoveGrantee,
  setDisplayDeletionModal,
  deletionMessage,
  setDeletingGrantee
}) => {
  const hideModal = () => {
    setDeletingGrantee({ id: null, index: null });
    setDisplayDeletionModal(false);
  };

  return (
    <Modal
      isDisplayed={isDisplayed}
      button1Label={'Confirmer la suppression'}
      button2Label={'Annuler'}
      onClose={hideModal}
      onClick1={handleRemoveGrantee}
      onClick2={hideModal}
      icon="circleReject">
      <div className="mx-auto text-primary font-medium text-xl text-center">
        <p>{deletionMessage}</p>
      </div>
    </Modal>
  );
};

export default DeleteBeneficiaryModal;
